import {createSlice} from '@reduxjs/toolkit'

export type ErrorState = {
    message?: string,
    type?: string,
    onClose?: () => void
}

const initialState: ErrorState = {}

const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        create: (state, action) => {
            return {
                ...state,
                ...action.payload,
            }
        },
        clear: () => {
            return {}
        }
    }
})

const { actions, reducer } = errorSlice
export const { create: createError, clear: clearError } = actions

export default reducer
